<template>
	<div class="cbs-radio-control">
		<legend class="flex justify-between items-center">
			<div>{{ localValue.title }}<span class="text-danger" v-if="!localValue.is_optional">&nbsp;*</span>:</div>
			<cbs-hint
				v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON"
				:data="localValue.description && localValue.description.value"
			/>
		</legend>

		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP">
			{{ localValue.description && localValue.description.value }}
		</div>
		<div class="flex mb-1 last:mb-0" v-for="option in localOptionsAttributeValue" :key="option.id">
			<vs-radio
				:vs-value="option.id"
				:data-vv-as="localValue.title"
				:name="`${localValue.title}-${localValue.id}`"
				v-model="localValue.value"
				v-validate="!localValue.is_optional ? 'required' : ''"
				>{{ option.content }}</vs-radio
			>
		</div>
		<span class="text-danger text-sm" v-if="!localValue.is_optional">{{ errors.first(`${localValue.title}-${localValue.id}`) }}</span>
		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM">
			{{ localValue.description && localValue.description.value }}
		</div>
	</div>
</template>

<script>
import CbsHint from "@/components/cbs-hint/CbsHint.vue";

export default {
	name: "RadioControl",
	inject: ["parentValidator"],
	components: {
		CbsHint
	},
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localOptionsAttributeValue() {
			return this.localAttributesValue.options || [];
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style></style>
